import { React, useEffect,useRef ,useState} from 'react';
import { isMobile } from 'react-device-detect';
import Header from './Header';
import { useNavigate  } from "react-router-dom";
import { authFetch, getAuthInfo, redirectToLogin } from './authFetch';


function Profile(props) {

    const [message, setMessage] = useState("");
    const [hidden, setHidden] = useState(true);
    const [email, setEmail] = useState("");
    const [paypal, setPaypal] = useState("");
    const [oldpassword, setOldPassword] = useState("");
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");



    const DataEndPoint = process.env.REACT_APP_DATA_END_POINT;
    const SaveEndPoint = process.env.REACT_APP_SAVEUSER_END_POINT;

    var userinfo;
    
    const openInSameTab = url => {
        window.open(url, '_self', 'noopener,noreferrer');
    };

    async function checkLogged(userinfo) {
        try {
            const response = await authFetch(DataEndPoint + userinfo.id, { method: 'GET' });
            const data = await response.json();
            if (data.statusCode === 401) {
                redirectToLogin();
                return;
            }
            setEmail(data.email);
            setPaypal(data.paypal);
        } catch (error) {
            redirectToLogin();
        }
    }

    async function saveData1() {
        userinfo = getAuthInfo();
        try {
            const response = await authFetch(SaveEndPoint, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "id": userinfo.id,
                    "paypal": paypal,
                })
            });
            const data = await response.json();
            if (data.id) {
                setMessage("success");
                setTimeout(() => {
                    setMessage("");
                }, 1000);
            }
        } catch (error) {
            setMessage("Error saving data");
        }
    };

    async function saveData2() {
        userinfo = getAuthInfo();
        if (password1 != password2 || password1 === "" || oldpassword === "") {
            if (oldpassword === "") {
                setMessage("Current Password Can't be blank");
                setTimeout(() => {
                    setMessage("");
                }, 1000);
            } else {
                setMessage("Passwords Don't match or blank");
                setTimeout(() => {
                    setMessage("");
                }, 1000);
            }
            return;
        }

        try {
            const response = await authFetch(SaveEndPoint, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "id": userinfo.id,
                    "oldpassword": oldpassword,
                    "password": password1,
                    "password2": password2,
                })
            });
            const data = await response.json();
            if (data.message) {
                setMessage(data.message);
                setTimeout(() => {
                    setMessage("");
                }, 1000);
            }
            if (data.id) {
                setMessage("success");
                setTimeout(() => {
                    setMessage("");
                }, 1000);
            }
        } catch (error) {
            setMessage("Error saving password");
        }
    }

    useEffect(() => {
        userinfo = getAuthInfo();
        if (userinfo?.token) {
            setHidden(false);
            checkLogged(userinfo)
        } else {
            setTimeout(() => {
                redirectToLogin();
            }, 5000);
        }
    }, []);

    


    return (
         
        < div className={'MainW'} >
             <Header bg={true} destination="/" from="about" />
             <div className={"mouse2 newbackToGalaxy text-xl"} onClick={(e) => openInSameTab('/')} > [ BACK TO GALAXY ] </div>
            {!hidden ?
                <>
            <div className='house  text-xl'>
             <div className='Email mt-10  text-xl'>
                {email}  
            </div>    
             <div className='profile  text-xl'>
             <div className="loginMessage" >{message}</div>
                <div className='left'>
               paypal<input className=' text-xl' type="text" value={paypal} onChange={e => setPaypal(e.target.value)} /><br />
               <div className={'mouse2 register btt'} onClick={(e) => saveData1()} >[Save]</div>
            
               </div>
               <div className='right text-xl'>
                Current Password:<input autoComplete='password' type="password" value={oldpassword} onChange={e => setOldPassword(e.target.value)} ></input><br />
                password<input type="password" value={password1} onChange={e => setPassword1(e.target.value)}></input><br />
                retype password<input type="password" value={password2} onChange={e => setPassword2(e.target.value)}></input><br />
                <div className={'mouse2 register btt'} onClick={(e) => saveData2()} >[Change Password]</div>
                </div>
                        </div>
                        </div>
                </>
                 :
                <>
                <div className='loginMessage'>You must be logged in to reach this part of the galaxy</div>
                </>
            }
                </div >
         
        )
}

export default Profile

